<se-fe-page>
  <se-fe-header
    seFePageHeader
    seFeDataTitle="SeMissingPersonaInfo"
    seFeDataSubtitle="Missing persona info library component"
    size="750">
  </se-fe-header>
  <div seFePageContent>
    <router-outlet></router-outlet>
  </div>
</se-fe-page>
